import React, { Suspense } from "react";
import { Spin } from "antd";

import { MESSAGE_WEBGL } from "./disposition3d";

// La vue 3D (three.js, ~600 Ko) est chargee a la demande : bundle separe.
const Vue3D = React.lazy(() => import("./Vue3D"));

// Detection de WebGL (sans charger three) ; ne leve jamais.
export function webglDisponible() {
  try {
    if (typeof window === "undefined" || !window.WebGLRenderingContext) return false;
    const canvas = document.createElement("canvas");
    return !!(canvas.getContext("webgl") || canvas.getContext("experimental-webgl"));
  } catch (e) {
    return false;
  }
}

function MessageVue3D({ texte }) {
  return (
    <div className="map-3d">
      <div className="map-3d-msg" role="alert">
        {texte}
      </div>
    </div>
  );
}

// Garde : une erreur de rendu ou de chargement du bundle 3D ne doit jamais blanchir la page.
export class ErreurVue3D extends React.Component {
  constructor(props) {
    super(props);
    this.state = { erreur: false };
  }

  static getDerivedStateFromError() {
    return { erreur: true };
  }

  componentDidCatch(erreur) {
    // eslint-disable-next-line no-console
    console.error("Vue 3D", erreur);
  }

  render() {
    if (this.state.erreur) {
      return (
        <MessageVue3D texte="La vue 3D n'a pas pu s'afficher (erreur de chargement ou de rendu WebGL). Utilisez une autre vue ou rechargez la page." />
      );
    }
    return this.props.children;
  }
}

export default function Vue3DConteneur({ envs, onEnv }) {
  if (!webglDisponible()) return <MessageVue3D texte={MESSAGE_WEBGL} />;
  return (
    <ErreurVue3D>
      <Suspense fallback={<Spin style={{ width: "100%", marginTop: 120 }} />}>
        <Vue3D envs={envs} onEnv={onEnv} />
      </Suspense>
    </ErreurVue3D>
  );
}
